import(/* webpackMode: "eager" */ "/root/repo/src/app/score-check/page.tsx");
